import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import {Sx} from 'app/types/common';
import {Tooltip} from 'app/components/sharedReactComponents/Tooltip';
import {DeviceApiService} from 'app/services/api/device/DeviceApiService';
import {downloadFile} from 'app/util/download';

type Props = Sx & {};

export function UsbPairing({sx}: Props) {
  const handleDownloadPairing = () => {
    const url = DeviceApiService.getNexusPairingFile();
    downloadFile(url);
  };

  return (
    <Stack sx={sx} alignItems="center" alignSelf="center" gap={2}>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography>Pair your Pearl Nexus device with configured USB stick</Typography>

        <Tooltip content="Download and copy the pairing file to a folder called EPIPHAN on a USB stick labelled EPIPHAN to pair your device">
          <HelpOutlineIcon fontSize="small" color="secondary" />
        </Tooltip>
      </Stack>

      <Button
        data-id="nexus-pairing-btn"
        variant="contained"
        color="secondary"
        size="large"
        startIcon={<FileOpenIcon />}
        disableRipple={false}
        onClick={handleDownloadPairing}
      >
        Get pairing file
      </Button>
    </Stack>
  );
}
